// RatingForm.jsx
import { Box, Button, Typography } from '@mui/material';
import LoadingSpinner from '@components/LottieSpinner';
import icon_mini_chat_rating_color from '@images/icon_mini_chat_rating_color.png';
import icon_mini_chat_rating_gray from '@images/icon_mini_chat_rating_gray.png';

const RatingForm = ({
  styles,
  t,
  isLoading,
  qualityRating,
  satisfactionRating,
  handleQualityRatingChange,
  handleSatisfactionRatingChange,
  handleSubmit,
}) => {
  return (
    <Box sx={styles.ratingContainer}>
      {isLoading && (
        <Box sx={styles.spinnerBox}>
          <LoadingSpinner />
        </Box>
      )}
      <>
        <Box sx={styles.ratingBox}>
          <Typography style={styles.ratingTitle}>{t('4520_chat_ratings.rate_your_experience')}</Typography>
        </Box>

        <Box sx={styles.divider} />
        <Box sx={styles.ratingBox}>
          <Typography style={styles.ratingSubtitle}>{t('4520_chat_ratings.how_was_the_quality_of_the_connection')}</Typography>
          <RatingComponent rating={qualityRating} onRatingChange={handleQualityRatingChange} />
        </Box>
        <Box sx={styles.divider} />
        <Box sx={styles.ratingBox}>
          <Typography style={styles.ratingSubtitle}>{t('4520_chat_ratings.how_satisfied_are_you_with_the_consultation')}</Typography>
          <RatingComponent rating={satisfactionRating} onRatingChange={handleSatisfactionRatingChange} />
        </Box>
        <Box sx={styles.submitWrapper}>
          <Button onClick={handleSubmit} sx={styles.submitButton} disabled={qualityRating === 0 || satisfactionRating === 0}>
            {t('0000_common.submit')}
          </Button>
        </Box>
      </>
    </Box>
  );
};

export default RatingForm;

const RatingComponent = ({ rating, onRatingChange }) => {
  const handleStarClick = (starIndex) => {
    onRatingChange(starIndex);
  };
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      {[1, 2, 3, 4, 5].map((starIndex) => (
        <Typography key={starIndex} onClick={() => handleStarClick(starIndex)} style={{ cursor: 'pointer' }}>
          {starIndex <= rating ? (
            <img style={{ width: '24px' }} src={icon_mini_chat_rating_color} alt="blue_star" />
          ) : (
            <img style={{ width: '24px' }} src={icon_mini_chat_rating_gray} alt="gray_star" />
          )}
        </Typography>
      ))}
    </Box>
  );
};
